import React from "react";
import { months } from "../../../../../../Utils/months";
import { RowNames } from "../../../Utils/TableComponents";
import LatexProcesoMonth from "./LatexProcesoMonth";

export default function LatexProcesoTable() {
    const rowNames = [
        'Entradas MP a producción',
        '(+) Gtos. De compra de MP',
        'Sub-total materia prima',
        '(-) SKIM',
        '(-) Coágulo lavado de pilas/centrifugas',
        '(-) Coágulo de Trampas',
        '(=) MP transf. En PP',
        '(+) Costo de proceso de centrifugado',
        '(=) PP costeado',
        '(+) Inv. Inicial de PP',
        '(+) Latex de maquila x formula',
        '(=) Disponible para Vta',
        '(-) Perdida (1%)',
        '(-) Coágulos centrifugado',
        '(+) Compras de PT',
        '(=) Inventario Final de PT',
        '(-) Costo Vta. Del Mes',
        '(=) Prod. Termin. Final'
    ];

    return (
        <div className="report__table-container">
            <h6>LÁTEX EN PROCESO</h6>
            <div className="report__month-tables">
                <RowNames rowNames={rowNames} totalRows={[2, 6, 8, 11, 15, 17]} />
                {months.map((month, index) => {
                    return (
                        <LatexProcesoMonth
                            key={index}
                            month={month}
                            monthIndex={index} />
                    )
                })}
            </div>
        </div>
    );
}
